// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "shared-" + chunkId + "." + "80bc8eb3335c7c5cc019" + ".js";
};